(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account-entry"]) return;
  try {
    
(() => {
  const init = (root = document) => {
    const dialog = root.querySelector?.('[data-private-waitlist-dialog]') || document.querySelector('[data-private-waitlist-dialog]');
    if (!dialog || dialog.dataset.ready === 'true') return;
    dialog.dataset.ready = 'true';

    const openers = document.querySelectorAll('[data-private-waitlist-open]');
    const close = dialog.querySelector('[data-private-waitlist-close]');
    let returnFocus = null;

    const openDialog = event => {
      returnFocus = event?.currentTarget || document.activeElement;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      dialog.querySelector('input[type="email"], [data-private-waitlist-success]')?.focus();
    };

    const closeDialog = () => {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
      returnFocus?.focus();
    };

    openers.forEach(button => button.addEventListener('click', openDialog));
    close?.addEventListener('click', closeDialog);
    dialog.addEventListener('click', event => {
      if (event.target === dialog) closeDialog();
    });

    if (dialog.querySelector('[data-private-waitlist-success]') || dialog.querySelector('.cd13-private-waitlist__errors')) openDialog();
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-cart-remove]');
    if (!button) return;

    event.preventDefault();
    if (button.disabled) return;

    button.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: button.dataset.lineKey, quantity: 0 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart change failed');
        window.location.reload();
      })
      .catch(function () {
        button.disabled = false;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-form-editor"] && !Shopify.designMode) return;
  try {
    
(() => {
  const esc = value => String(value || '').replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const widthClass = width => ({half:'cd13-project-request__field--half',third:'cd13-project-request__field--third',two_thirds:'cd13-project-request__field--two-thirds'}[width] || '');
  const nativeNames = {name:'contact[name]',email:'contact[email]',phone:'contact[phone]',company:'contact[Société]',quantity:'contact[Quantité]',dimensions:'contact[Dimensions souhaitées]',deadline:'contact[Délai souhaité]',message:'contact[body]'};
  const nativeTypes = {name:'text',email:'email',phone:'tel',company:'text',quantity:'number',dimensions:'text',deadline:'text'};
  const customName = s => `contact[${String(s.field_name || s.label || 'Information complémentaire').trim()}]`;
  const label = s => `${s.label || ''}${s.required ? ' *' : ''}`;
  const help = s => s.help_text ? `<small>${esc(s.help_text)}</small>` : '';
  const defaults = () => [
    {id:'name',type:'name',settings:{label:'Nom et prénom',required:true,width:'half'}},{id:'company',type:'company',settings:{label:'Société',width:'half'}},
    {id:'email',type:'email',settings:{label:'E-mail',required:true,width:'half'}},{id:'phone',type:'phone',settings:{label:'Téléphone',required:true,width:'half'}},
    {id:'quantity',type:'quantity',settings:{label:'Quantité',width:'third'}},{id:'dimensions',type:'dimensions',settings:{label:'Dimensions souhaitées',placeholder:'Ex. 800 × 650 × 1 500 mm',width:'third'}},
    {id:'deadline',type:'deadline',settings:{label:'Délai souhaité',placeholder:'Ex. avant fin septembre',width:'third'}},{id:'message',type:'message',settings:{label:'Modifications souhaitées',placeholder:'Dimensions, matériaux, équipements, implantation, contraintes techniques…',required:true,rows:7,width:'full'}},
    {id:'consent',type:'consent',settings:{label:'J’accepte que Clé de 13 utilise ces informations pour répondre à ma demande.',required:true,width:'full'}}
  ];
  const render = (block, saved) => {
    const s = block.settings || {}, type = block.type, wrap = `cd13-project-request__field ${widthClass(s.width)}`.trim(), attrs = `data-shopify-editor-block="${esc(block.id)}"`;
    if (type === 'heading') return `<div class="cd13-project-request__field-heading" ${attrs}><h3>${esc(s.title)}</h3>${s.text ? `<p>${esc(s.text)}</p>` : ''}</div>`;
    if (type === 'separator') return `<div class="cd13-project-request__separator" ${attrs}></div>`;
    if (type === 'consent') return `<label class="${wrap} cd13-project-request__choice" ${attrs}><input type="checkbox" ${s.required ? 'required' : ''}><span>${esc(s.label)}</span></label>`;
    const name = nativeNames[type] || customName(s), value = saved[name] || s.default_value || (type === 'quantity' ? '1' : '');
    if (type === 'message' || type === 'textarea') return `<label class="${wrap}" ${attrs}><span>${esc(label(s))}</span><textarea name="${esc(name)}" rows="${Number(s.rows || 6)}" placeholder="${esc(s.placeholder)}" ${s.required ? 'required' : ''}>${esc(value)}</textarea>${help(s)}</label>`;
    if (type === 'select') {
      const options = String(s.options || '').split(/\r?\n/).map(v => v.trim()).filter(Boolean);
      return `<label class="${wrap}" ${attrs}><span>${esc(label(s))}</span><select name="${esc(name)}" ${s.required ? 'required' : ''}><option value="">${esc(s.placeholder || 'Sélectionner')}</option>${options.map(v => `<option value="${esc(v)}" ${v === value ? 'selected' : ''}>${esc(v)}</option>`).join('')}</select>${help(s)}</label>`;
    }
    if (type === 'radio' || type === 'checkbox_group') {
      const options = String(s.options || '').split(/\r?\n/).map(v => v.trim()).filter(Boolean), inputType = type === 'radio' ? 'radio' : 'checkbox', finalName = type === 'checkbox_group' ? `${name}[]` : name;
      return `<fieldset class="${wrap}" ${attrs}><legend>${esc(label(s))}</legend><div class="cd13-project-request__choices">${options.map((v,i) => `<label class="cd13-project-request__choice"><input type="${inputType}" name="${esc(finalName)}" value="${esc(v)}" ${s.required && i === 0 ? 'required' : ''}><span>${esc(v)}</span></label>`).join('')}</div>${help(s)}</fieldset>`;
    }
    const inputType = nativeTypes[type] || 'text', min = type === 'quantity' ? 'min="1"' : '', sync = type === 'quantity' ? 'data-project-request-quantity' : '', autocomplete = ({name:'name',email:'email',phone:'tel',company:'organization'}[type] || 'off');
    return `<label class="${wrap}" ${attrs}><span>${esc(label(s))}</span><input type="${inputType}" name="${esc(name)}" value="${esc(value)}" placeholder="${esc(s.placeholder)}" autocomplete="${autocomplete}" ${min} ${sync} ${s.required ? 'required' : ''}>${help(s)}</label>`;
  };
  const addRepeat = (dialog,editor) => { const success = dialog.querySelector('[data-project-request-success]'); if (!success) return; let a = success.querySelector('[data-project-request-again]'); if (!a) { a=document.createElement('a'); a.className='cd13-project-request__repeat'; a.dataset.projectRequestAgain=''; success.appendChild(a); } a.textContent=editor.dataset.repeatLabel || 'Faire une autre demande'; const u=new URL(location.href); u.searchParams.delete('contact_posted'); u.searchParams.set('open_project_request','1'); a.href=u.pathname+u.search; };
  const apply = editor => {
    const dialog = document.querySelector('[data-project-request-dialog]'); if (!dialog) return;
    dialog.hidden = editor.dataset.enabled !== 'true'; dialog.style.setProperty('--cd13-form-gap', `${editor.dataset.fieldsGap || 14}px`);
    const panel = dialog.querySelector('.cd13-project-request__panel'); if (panel) panel.style.width = `min(${editor.dataset.panelWidth || 760}px,calc(100% - 24px))`;
    const set = (selector,text) => { const el = dialog.querySelector(selector); if (el) el.textContent = text || ''; };
    set('.cd13-project-request__eyebrow',editor.dataset.eyebrow); set('.cd13-project-request__heading h2',editor.dataset.title); set('.cd13-project-request__heading>p:last-child',editor.dataset.intro);
    set('[data-project-request-submit]',editor.dataset.submitLabel); set('.cd13-project-request__note',editor.dataset.note); set('.cd13-project-request__success strong',editor.dataset.successTitle); set('.cd13-project-request__success p',editor.dataset.successText);
    const form = dialog.querySelector('form'); if (!form || dialog.querySelector('[data-project-request-success]')) return addRepeat(dialog,editor);
    const saved = {}; form.querySelectorAll('input[name],textarea[name],select[name]').forEach(el => { if (!el.type || !['hidden','checkbox','radio'].includes(el.type)) saved[el.name] = el.value; });
    form.querySelectorAll('.cd13-project-request__fields,.cd13-project-request__message,.cd13-project-request__consent,.cd13-project-request__dynamic-fields').forEach(el => el.remove());
    let blocks = []; try { blocks = JSON.parse(editor.querySelector('[data-project-form-blocks]')?.textContent || '[]'); } catch(e) {}
    if (!blocks.length) blocks = defaults();
    if (!blocks.some(b => b.type === 'email')) blocks.unshift(defaults()[2]); if (!blocks.some(b => b.type === 'message')) blocks.push(defaults()[7]);
    const container = document.createElement('div'); container.className = 'cd13-project-request__dynamic-fields'; container.innerHTML = blocks.map(b => render(b,saved)).join('');
    const submit = form.querySelector('[data-project-request-submit]'); form.insertBefore(container,submit); if (new URLSearchParams(location.search).get('open_project_request') === '1' && !dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
  };
  const init = scope => (scope || document).querySelectorAll?.('[data-project-form-editor]').forEach(apply);
  document.addEventListener('DOMContentLoaded',()=>init(document)); document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();
})();
